import { render, staticRenderFns } from "./KitCameraPlaceholder.vue?vue&type=template&id=4d490b7f"
import script from "./KitCameraPlaceholder.vue?vue&type=script&lang=ts"
export * from "./KitCameraPlaceholder.vue?vue&type=script&lang=ts"
import style0 from "./KitCameraPlaceholder.vue?vue&type=style&index=0&id=4d490b7f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports